import React from 'react';
import { Button, Flex, Result } from 'antd';
import { logout } from 'myredux/loginSlice';
import { useDefault } from 'hooks/useDefault';


const Custom500: React.FC = () => {
    const { navigation, dispatch } = useDefault();
    
    return (
        <Result
            status="500"
            title="500"
            subTitle="Neočekávaná chyba aplikace."
            extra={<Flex vertical align='center' gap="middle">
                <Button type="primary" onClick={() => navigation('/secured/cashdesk')}>Zpět na pokladnu</Button>
                <Button onClick={() => dispatch(logout())}>Odhlásit se</Button>
                </Flex>}
        />
    );
};

export default Custom500;